import EventEmitter from 'events';

class LoaderService extends EventEmitter {
  showLoader() {
    this.emit('change', true);
  }

  hideLoader() {
    this.emit('change', false);
  }

  // Alias para compatibilidad
  show() {
    this.showLoader();
  }

  hide() {
    this.hideLoader();
  }
}

export const loaderService = new LoaderService();
